import React from 'react';
import styles from './Stepper.module.scss';

export type StepperProps = {
  steps: {
    label: string;
    isActiveStep?: boolean;
  }[];
};

export const Stepper: React.FC<StepperProps> = ({ steps }: StepperProps) => {
  const activeIndex = steps.findIndex((elem) => elem.isActiveStep);
  return (
    <div className={styles.container}>
      {steps &&
        steps.map((elem, index) => {
          return (
            <p
              key={elem.label + '_' + index}
              className={`${styles.step} ${index === steps.length - 1 ? styles.last : ''} ${
                elem.isActiveStep ? styles.active : ''
              } ${index < activeIndex ? styles.completed : ''}`}
            >
              <span className={styles.label}>{elem.label}</span>
            </p>
          );
        })}
    </div>
  );
};
